export const breakpoints = {
  sm: '20rem',
  md: '48rem',
  lg: '64rem',
};
